import {axios} from "../../utils/axios";

export function postLogin(props: LoginReq) {
  return axios.post('/signin', props);
}

export function getProfile() {
  return axios.get('profile').then(res => res.data);
}
